// Static list generated from https://restcountries.com/v3.1/all?fields=name
import countriesJson from "@lib/shared/countries.json";
import type { Option } from "@sprout/select";

export const COUNTRIES: Option[] = countriesJson as Option[];
